<template>
    <v-container fluid grid-list-md>
        <loader :show="$anyLoading()" :message="messageLoader"></loader>

        <confirm-modal
          :dialog="showConfirm"
          :message="confirmText"
          @confirm="confirmResponse($event)"></confirm-modal>

          <!-- DIALOGO DE JUGADORES DE UN EQUIPO -->
          <players-of-team
          @close="closePlayersOfTeam()"
          :teamName="selectedTeamName"
          :teamId="selectedTeamId"/>
          <!-- FIN DIALOGO DE JUGADORES DE UN EQUIPO -->

          <!-- PETITION DETAIL DIALOG -->

          <v-dialog
          v-model="petitionDetailDialog"
          fullscreen
          transition="dialog-bottom-transition"
          :overlay="false"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="green">
            <v-btn icon @click.native="hidePetitionDetail()" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalle de solicitud de acceso</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click.native="resolvePetition(true)">Aceptar</v-btn>
            </v-toolbar-items>
            <v-toolbar-items>
              <v-btn dark flat @click.native="resolvePetition(false)">Rechazar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <partnering :tournament="currentTournament" :petition="currentPetition"></partnering>

          </v-card-text>

          <div style="flex: 1 1 auto;"/>
        </v-card>
      </v-dialog>

          <!-- END PETITION DETAIL DIALOG -->

          <!-- DIALOGO PARA AGREGAR GRUPO -->
          <simple-text-input
            @confirm="confirmGroupDialog"
            :dialog="groupDialog"
             :labelText="'Nombre de grupo'"
             :default="selectedGroup ? selectedGroup.name : ''"
             positiveText="Aceptar">
           </simple-text-input>

      <!-- END DIALOGO PARA AGREGAR GRUPO  -->

      <!-- DETALLE DE UN JUGADOR LIGADO -->

      <v-dialog
      v-model="playerOfficialInfoVisible"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      @close="playerOfficialInfoVisible = false"
      scrollable>
        <player-official-info  :player="selectedPlayer" />
      </v-dialog>

      <!-- FIN DETALLE DE UN JUGADOR LIGADO -->

        <v-layout row wrap>
            <v-flex xs10 offset-xs1 mb-2>
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>{{currentTournament.name}}</span>
                <span class="ml-3 mr-3">></span>
                <span>Equipos</span>
            </v-flex>
            <v-flex xs10 offset-xs1>
                <v-text-field
                    box
                    label="Buscar equipos"
                    class="green--text"
                    v-model="filter"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs10 offset-xs1>
                <v-tabs left :centered="false" light v-model="active">
                    <v-tabs-bar class="transparent">
                        <v-tabs-item
                            v-for="tab in tabs"
                            :key="tab.key"
                            :href="'#' + tab.key"
                            ripple
                            @click="filter = ''">

                            {{ tab.title }}
                        </v-tabs-item>
                        <v-tabs-slider color="green"></v-tabs-slider>
                    </v-tabs-bar>
                   <v-tabs-items>
                      <!-- TAB 1  Equipos en el torneo -->
                        <v-tabs-content key="tab1" id="tab1">
                            <v-container fluid grid-list-xs mt-3>
                              <!-- Vista de equipos normal -->
                                <v-layout row wrap v-if="currentTournament.mode == 'normal'">
                                    <v-flex xs12 sm6 md4 lg3 v-for="(team, i) in teamsWithTournament" :key="i">
                                        <team-card
                                            :actionBtn="{ color: 'red', msg: 'Abandonar torneo', icon: 'remove' }"
                                            :cardInfo="team"
                                            :add="removeTeamMode"
                                            @unlink="unlink($event)"
                                            @add="submitTeam($event)"
                                            @selectplayer="viewOfficialInfo($event)"
                                            @showplayers="showPlayersOfTeams($event)"
                                            :tournamentFinalized="currentTournament.status == 'finalized'"
                                        ></team-card>
                                    </v-flex>
                                </v-layout>
                                <!-- Vista de equipos en grupos -->
                                <v-layout row wrap v-if="currentTournament.mode == 'groups'">
                                    <v-flex xs12 sm12 md12 >
                                      <v-btn color="green darken-1"  @click.native="openGroupDialog()">Nuevo grupo</v-btn>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                      <h5>Equipos sin grupo</h5>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 lg3 v-for="(team, x) in currentTournamentTeamsWhitoutGroup" :key="x">
                                        <team-card
                                            :actionBtn="{ color: 'red', msg: 'Abandonar torneo', icon: 'remove' }"
                                            :cardInfo="team"
                                            :add="removeTeamMode"
                                            @unlink="unlink($event)"
                                            @add="submitTeam($event)"
                                            @selectplayer="viewOfficialInfo($event)"
                                            @showplayers="showPlayersOfTeams($event)"
                                            :enableGroupSelector ="true"
                                            :tournamentFinalized="currentTournament.status == 'finalized'"
                                        ></team-card>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12 v-for="(group, i) in currentTournamentGroups" :key="i">
                                      <v-layout row wrap>

                                        <v-flex xs12 sm12 md12 >
                                          <h4 style="float:left">{{group.name}}</h4>
                                          <div style="float:left">
                                            <v-tooltip top>
                                              <v-btn :fab="false"  small icon outline slot="activator"  color="green"   small dark @click="openGroupDialog(group)">
                                                <v-icon>edit</v-icon>
                                              </v-btn>
                                              <span>Editar grupo</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                              <v-btn :fab="false"  small icon outline slot="activator"  color="red"   small dark @click="deleteGroup(group)">
                                                <v-icon>delete_forever</v-icon>
                                              </v-btn>
                                              <span>Eliminar grupo</span>
                                            </v-tooltip>
                                          </div>

                                          <div style="float:left">

                                          </div>

                                        </v-flex>
                                        <v-flex xs12 sm6 md4 lg3 v-for="(team, x) in group.teams" :key="x">
                                            <team-card
                                                :actionBtn="{ color: 'red', msg: 'Abandonar torneo', icon: 'remove' }"
                                                :cardInfo="team"
                                                :enableGroupSelector ="true"
                                                :add="removeTeamMode"
                                                :group = "group"
                                                @unlink="unlink($event)"
                                                @add="submitTeam($event)"
                                                @selectplayer="viewOfficialInfo($event)"
                                                @showplayers="showPlayersOfTeams($event)"
                                                :tournamentFinalized="currentTournament.status == 'finalized'"
                                            ></team-card>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-tabs-content>
                        <!-- TAB 2  Todos los equipos -->
                        <v-tabs-content key="tab2" id="tab2">
                            <v-container fluid grid-list-xs mt-3>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md4 lg3 v-for="(team, i) in teamsWithoutTournament" :key="i">
                                        <team-card
                                            :disable="existInTeamsWihtTournament(team)"
                                            :cardInfo="team"
                                            :add="addTeamMode"
                                            @add="submitTeam($event)"
                                            :tournamentFinalized="currentTournament.status == 'finalized'"
                                        ></team-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tabs-content>
                        <!-- TAB 3 Solicitudes de acceso -->
                        <v-tabs-content key="tab3" id="tab3">
                            <v-container fluid grid-list-xs mt-3>
                                <v-layout row wrap>
                                      <v-data-table
                                        :headers="requestTableHeaders"
                                        :items="currentAccessPetitions"
                                        hide-actions
                                        class="elevation-1">
                                        <template slot="items" slot-scope="props">
                                          <td class="text-xs-center">{{ props.item.id }}</td>
                                          <td class="text-xs-center">{{ props.item.team.name + " (" +  props.item.team.created_by +")"}}</td>
                                          <td class="text-xs-center">{{ props.item.requested_team ? props.item.requested_team.name : "" }}</td>
                                          <td class="text-xs-center">
                                            <v-btn outline @click="viewPetitionDetail(props.item)" color="green" small light flat>Ver Detalle</v-btn>
                                          </td>
                                        </template>
                                      </v-data-table>
                                </v-layout>
                            </v-container>
                        </v-tabs-content>

                    </v-tabs-items>
                </v-tabs>
                <br>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Team from '@/models/team'
import TeamCard from './TeamCard'
import PlayerOfficialInfo from './PlayerOfficialInfo'
import PlayersOfTeam from './PlayersOfTeam'
import Partnering from '@/components/pages/partnering/partnering'
import SimpleTextInput from '@/components/helpers/modals/SimpleTextInput'

/*
<v-dialog
v-model="playerOfficialInfoVisible"
fullscreen
transition="dialog-bottom-transition"
:overlay="false"
scrollable>
  <player-official-info  :player="selectedPlayer" />
</v-dialog>
*/
export default {
    name: 'Teams',
    components: {
        TeamCard,
        PlayerOfficialInfo,
        SimpleTextInput,
        PlayersOfTeam
    },
    data() {
        return {
            selectedTeamId: null,
            selectedTeamName: "",
            currentPetition:null,
            playerOfficialInfoVisible:false,
            selectedPlayer:null,
            petitionDetailDialog:false,
            showConfirm:false,
            confirmDialogType:"",
            confirmText:"",
            teamIdToRemove:null,
            teamIdToUnlink:null,
            messageLoader: 'Cargando Información...',
            addTeamMode: true,
            removeTeamMode: false,
            active: 'tab1',
            groupDialog:false,
            selectedGroup:null,
            filter: '',
            tabs: [
                { key: 'tab1', title: 'PARTICIPANTES EN TORNEO' },
                { key: 'tab2', title: 'TODOS LOS EQUIPOS' },
                { key: 'tab3', title: 'SOLICITUDES DE ACCESO' }
            ],
            requestTableHeaders:[
              { text: 'id', value: 'id', align: 'center' },
              { text: 'Equipo solicitante', value: '', align: 'center' },
              { text: 'Equipo solicitado', value: '', align: 'center' },
              { text: '', value: '', align: 'center' }
            ]
        }
    },
    watch: {
        currentTournament(val) {
            console.log(val)
        }
    },
    computed: {
        ...mapGetters([
            'currentTeams',
            'currentTournamentTeams',
            'currentTournament',
            'currentAccessPetitions',
            'currentTournamentGroups',
            'currentTournamentTeamsWhitoutGroup'
        ]),
        teamsWithoutTournament(type) {
            let x = []

            if(this.currentTeams){
                this.currentTeams.forEach(team => {

                    if(this.filter === '' || team.name.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase())) {
                      if(team.tournament == null || team.tournament.id == this.currentTournament.id){
                        x.push(team)
                      }
                    }
                })
            }

            return x
        },
        teamsWithTournament(type) {
            let x = []

            if(this.currentTournamentTeams){
                this.currentTournamentTeams.forEach(team => {
                    if(this.filter === '' || team.name.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase())) {
                        x.push(team)
                    }
                })
            }

            return x
        }
    },
    created() {
        this.loadTeams()
        this.loadTournamentTeams(this.$route.params.tournamentID)
        this.loadTournamentAccessPetitions(this.$route.params.tournamentID)
    },
    methods: {
        ...mapActions([
            'loadTeams',
            'associateTeam',
            'removeTeamFromTournament',
            'loadTournamentAccessPetitions',
            'resolveAccessPetition',
            'unlinkTeam',
            'createGroup',
            'loadTournamentTeams',
            'editGroup',
            'removeGroup'
        ]),
        submitTeam(event) {
            if(event.addTeamMode) {
                let data = { teamID: event.id, tournamentID: this.$route.params.tournamentID }
                this.associateTeam(data)
            } else {
                this.confirmDialogType = "removeteam"
                this.confirmText = "Al remover este equipo del torneo se eliminarán todos los resultados de los partidos jugados por el equipo ¿estás seguro?"
                this.showConfirm = true
                this.teamIdToRemove = event.id
            }
        },
        unlink(event){
          this.confirmDialogType = "unlinkteam"
          this.confirmText = "Al presionar 'Si' estarás desligando a este equipo y así evitando que vea la información de este torneo en Pitz App, ¿Estás seguro que deseas continuar? "
          this.showConfirm = true
          this.teamIdToUnlink = event.id
        },
        existInTeamsWihtTournament(team){
          for(var i in this.currentTournamentTeams){
            if(team.id == this.currentTournamentTeams[i].id){
              return true
            }
          }
          return false
        },
        confirmResponse(response){
          this.showConfirm = false
          if(response){
            if(this.confirmDialogType == "unlinkteam"){
                let data = { teamId: this.teamIdToUnlink, tournamentId: this.$route.params.tournamentID }
                this.unlinkTeam(data)
            }else if(this.confirmDialogType == "removeteam"){
              let data = {
                  tournamentID: this.$route.params.tournamentID,
                  teamID: this.teamIdToRemove
              }
              this.removeTeamFromTournament(data)
            }
          }
        },
        viewPetitionDetail(petition){
          this.currentPetition = petition
          this.petitionDetailDialog = true
        },
        hidePetitionDetail(){
          this.currentPetition = null
          this.petitionDetailDialog = false
        },
        resolvePetition(accepted){
          let data = {
            tournamentId: this.currentTournament.id,
            petitionId: this.currentPetition.id,
            accepted: accepted
          }
          this.hidePetitionDetail()
          this.resolveAccessPetition(data)

        },
        viewOfficialInfo(event){
          this.playerOfficialInfoVisible = true
          this.selectedPlayer = event
        },
        confirmGroupDialog(confirm,value){
          this.groupDialog = false
          if(confirm){
            var data = {
              tournamentId : this.currentTournament.id,
              groupName : value
            }
            if(this.selectedGroup){
              data.groupId = this.selectedGroup.id
              this.editGroup(data)
              return
            }

            this.createGroup(data)
          }
        },
        openGroupDialog(group){
          this.selectedGroup = group
          this.groupDialog = true
        },
        deleteGroup(group){
          let data = {
            tournamentId:this.currentTournament.id,
            groupId:group.id
          }
          this.removeGroup(data)
        },
        showPlayersOfTeams(event){
          this.selectedTeamId = event.id
          this.selectedTeamName = event.name
        },
        closePlayersOfTeam(){
          this.selectedTeamId = null
          this.selectedTeamName = ""
        }


    }
}
</script>

<style lang="css" scoped>
    .fab-img {
        width: 60px;
        height: 60px;
        position: absolute;
        border-radius: 50%;
        bottom: -30px;
        box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px rgba(0,0,0,.14), 0 1px 18px rgba(0,0,0,.12);
        right: 0;
    }
    .card__media {
        overflow: visible !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/teams/Teams.vue